import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowAltCircleDown, faEye, faPenToSquare } from "@fortawesome/free-solid-svg-icons"
import {  useNavigate, useParams } from 'react-router-dom'
import { useGetMessagesQuery } from '../messageApiSlice'
import { memo } from 'react'
import useAuth from "../../../hooks/useAuth"
import TimeLeft from '../../../partial/TimeLeft'
import ReactQuill from 'react-quill';
import AddComment from './AddComment'
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import { Box } from '@mui/material'

const Message = ({ message }) => {
    const {groupId} = useParams()
    const { isTeacher, isAdmin, isStudent } = useAuth()





    const navigate = useNavigate()
  

    if (message) {
       

       
         
   
  
        return (
<div>

<Accordion  className='accordion-header accordion-root'    style={{background:"transparent", "color":"white", "marginTop":"5px", marginBottom:"10px"}}>
        <AccordionSummary
      
          expandIcon={<FontAwesomeIcon color='white' icon={faArrowAltCircleDown} />}
          aria-controls="panel1a-content"
          id="panel1a-header"
          style={{}}
        >
          <Typography   >{message.title}</Typography> <br/>
          <Typography    style={{color:"#ccc", opacity:"0.6", marginRight:"10px"}}  >({message.group?.name})</Typography>
        </AccordionSummary>
        <AccordionDetails  >
            <Box>
        <ReactQuill
                     theme='bubble'
                    readOnly
                    value={ message.body}
                    
                    ></ReactQuill>
                    </Box>

<div> { message.comments?.length > 0 && message.comments.map(comment=> <div key={comment._id} >  <br /> 🕑︎ {comment.date.toString().slice(0,10)} <br/> &nbsp;&nbsp;&nbsp;&nbsp; {comment.title} </div>)}</div>
<AddComment messageId={message._id} />
        </AccordionDetails>
      </Accordion>

    <h2></h2>


                 
</div>



           
        )

    } else return null
}

const memoizedMessage = memo(Message)

export default memoizedMessage